import { useLabelsContext } from "../../context/LabelsContext";
import { FieldLabel } from "./FieldLabel";
import { DateSelect } from "./DateSelect";
import {
	Control,
	Controller,
	FieldErrors,
	UseFormRegister,
	UseFormSetValue,
	UseFormTrigger,
	UseFormWatch,
} from "react-hook-form";
import { RegistrationFields } from "../../models/registration-fields";

type SpouseFieldsProps = {
	errors: FieldErrors<RegistrationFields>;
	registrationForm: Record<keyof RegistrationFields, any>;
	trigger: UseFormTrigger<RegistrationFields>;
	register: UseFormRegister<RegistrationFields>;
	getErrorMessage: (
		field: keyof RegistrationFields,
	) => { key: string; message: string } | null;
	getFieldRequirement: (
		field: keyof RegistrationFields,
	) => "required" | "optional" | "none";
	control: Control<RegistrationFields>;
	watch: UseFormWatch<RegistrationFields>;
	setValue: UseFormSetValue<RegistrationFields>;
};
export const SpouseFields: React.FC<SpouseFieldsProps> = ({
	errors,
	registrationForm,
	trigger,
	register,
	getErrorMessage,
	getFieldRequirement,
	control,
	watch,
	setValue,
}: SpouseFieldsProps) => {
	const { labels } = useLabelsContext();

	return (
		<div className='form-grid'>
			{getFieldRequirement("spouseFirstName") !== "none" && (
				<div>
					{getErrorMessage("spouseFirstName") && (
						<span
							className={`error-message key-${getErrorMessage("spouseFirstName")?.key}`}
						>
							{getErrorMessage("spouseFirstName")?.message}
						</span>
					)}
					<div
						className={`form-field ${errors.spouseFirstName ? "has-error" : ""}`}
					>
						<input
							id='spouseFirstName'
							type='text'
							placeholder=' '
							{...register(
								"spouseFirstName",
								registrationForm.spouseFirstName,
							)}
							onBlur={() => trigger("spouseFirstName")}
						/>
						<FieldLabel
							field={"spouseFirstName"}
							label={labels?.["firstNameSpouse"]}
						/>
					</div>
				</div>
			)}
			{getFieldRequirement("spouseLastName") !== "none" && (
				<div>
					{getErrorMessage("spouseLastName") && (
						<span
							className={`error-message key-${getErrorMessage("spouseLastName")?.key}`}
						>
							{getErrorMessage("spouseLastName")?.message}
						</span>
					)}
					<div
						className={`form-field ${errors.spouseLastName ? "has-error" : ""}`}
					>
						<input
							id='spouseLastName'
							type='text'
							placeholder=' '
							{...register(
								"spouseLastName",
								registrationForm.spouseLastName,
							)}
							onBlur={() => trigger("spouseLastName")}
						/>
						<FieldLabel
							field={"spouseLastName"}
							label={labels?.["lastNameSpouse"]}
						/>
					</div>
				</div>
			)}
			{getFieldRequirement("spouseBirthDate") !== "none" && (
				<div>
					<div
						className={`form-select ${errors.spouseBirthDate ? "has-error" : ""}`}
					>
						<FieldLabel
							field={"spouseBirthDate"}
							label={labels?.["SpouseDateOfBirth"]}
						/>
						<Controller
							name='spouseBirthDate'
							control={control}
							rules={registrationForm.spouseBirthDate}
							render={({ field, fieldState }) => (
								<DateSelect
									field='spouseBirthDate'
									value={field.value}
									onChange={field.onChange}
									onBlur={field.onBlur}
									hasError={!!fieldState.error}
									minAge={18}
								/>
							)}
						/>
					</div>
				</div>
			)}
			{getFieldRequirement("anniversary") !== "none" && (
				<div>
					<div
						className={`form-select ${errors.anniversary ? "has-error" : ""}`}
					>
						<FieldLabel
							field={"anniversary"}
							label={labels?.["AnniversaryLabel"]}
						/>
						<Controller
							name='anniversary'
							control={control}
							rules={registrationForm.anniversary}
							render={({ field, fieldState }) => (
								<DateSelect
									field='anniversary'
									value={field.value}
									onChange={field.onChange}
									onBlur={field.onBlur}
									hasError={!!fieldState.error}
								/>
							)}
						/>
					</div>
				</div>
			)}
		</div>
	);
};
